import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AnimationsService } from '../animations.service';
import { API } from '../api';
import { ErrorHandlerService } from '../error-handler.service';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AtendimentoService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  getPorId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('idAtendimento', id);
    const usuario = this.authService.getToken();
    return this.http.get(
      `${environment.baseUrl}${API.atendimento.buscarPorId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao obter o atendimento', []
        )
        )
      );
  }

  getPorCelular(celular): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('celularCliente', celular);
    const usuario = this.authService.getToken();
    return this.http.get(
      `${environment.baseUrl}${API.atendimento.buscaIdPorNumerodeCelular}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao obter o atendimento', []
        )
        )
      );
  }

  getAgendamentos(id): Observable<any> {    
    const params: HttpParams = new HttpParams().set('idUnidade', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.atendimento.buscarAgendamentos}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter os atendimentos agendados', []))
      );
  }

  getNumeroDeAtendimentos(idUnidade): Observable<any> {
    const params: HttpParams = new HttpParams().set('idUnidade', idUnidade);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.atendimento.numeroDeAtendimentos}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a quantidade de atendimentos', []))
      );
  }

  getFiltraAtendimentos(filtro): Observable<any> {
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.atendimento.filtraAtndimentos}`, filtro, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter os atendimentos', []))
      );
  }

  getAgendamentoIdAtendimento(id): Observable<any> {
    const params: HttpParams = new HttpParams().set('idAtendimento', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.atendimento.buscarAgendamentosPorIdAtendimento}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter o agendamento', []))
      );
  }

  getAgendamentoId(id): Observable<any> {
    const params: HttpParams = new HttpParams().set('id', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.agendamento.buscarAgendamentoPorId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter o agendamento', []))
      );
  }

  cadastrar(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();    
    return this.http.post(
      `${environment.baseUrl}${API.atendimento.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao enviar os dados', [])
        )
      );
  }

  atualizar(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();    
    return this.http.post(
      `${environment.baseUrl}${API.atendimento.atualizar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao enviar os dados', [])
        )
      );
  }

  editar(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();    
    return this.http.post(
      `${environment.baseUrl}${API.atendimento.editar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao enviar os dados', [])
        )
      );
  }

  cadastrarAgendamento(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(
      `${environment.baseUrl}${API.agendamento.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao enviar os dados', [])
        )
      );
  }

  atualizaAgendamento(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(
      `${environment.baseUrl}${API.atendimento.atualizaAgendamento}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Falha ao enviar os dados', [])
        )
      );
  }

  getHistoricoAgendamentos(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('idAtendimento', id);
    const usuario = this.authService.getToken();
    return this.http.get(
      `${environment.baseUrl}${API.atendimento.historicoAgendamentos}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Não existem Historico!', []
        )
        )
      );
  }

  getFiltraAgendamentosPorData(data, idUnidade): Observable<any> {
    const params: HttpParams = new HttpParams().set('data', data).set('idUnidade', idUnidade);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.agendamento.filtraAgendamentosPorData}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter o agendamento', []))
      );
  }
}
